module.exports = __webpack_public_path__ + "static/media/Location_solid.426af8e3.svg";